<div>
    <h1>{{ propertyLabel }}</h1>
    <p-table [value]="propertyModelList" [reorderableColumns]="true" dataKey="id" editMode="row"
             (onRowReorder)="onRowReorder($event)">
        <ng-template pTemplate="header">
            <tr>
                <th style="width:3rem"></th>
                <th pReorderableColumn>Order</th>
                <th pReorderableColumn>Key</th>
                <th pReorderableColumn>Label</th>
                <th pReorderableColumn>Value</th>
                <th pReorderableColumn>Lang</th>
                <th pReorderableColumn>Gewichtung</th>
                <th style="width:8rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-property let-editing="editing" let-index="rowIndex" let-ri="rowIndex">
            <tr [pEditableRow]="property" [pReorderableRow]="index">
                <td>
                    <span class="pi pi-bars" pReorderableRowHandle></span>
                </td>
                <td>
                    {{ index }}
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.dtype" readonly>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ property.dtype }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.dtext" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ property.dtext }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.dkey" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ property.dkey }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <!--<input pInputText type="text" [(ngModel)]="property.language">-->
                            <p-dropdown [options]="languages" [(ngModel)]="property.language"
                                        [style]="{'width':'100%'}"></p-dropdown>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ property.language }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="property.weighting" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ property.weighting }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td style="text-align:center">
                    <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                            (click)="onRowEditInit(property)" class="p-button-rounded p-button-text"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                            (click)="onRowEditSave(property)"
                            class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                            (click)="onRowEditCancel(property, ri)"
                            class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="float-right">

        <button pButton pRipple type="button" label="{{'sp-add-new-item' | translate}}" icon="pi pi-plus"
                class="p-button-outlined float-left" (click)="addNewProperty()"></button>
        <span class="float-left"> &nbsp; </span>
        <p-button label="{{'sp-save' | translate}}" icon="pi pi-check" class="float-left"
                  (click)="saveProperties()"></p-button>

    </div>

</div>
